import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'

import ThumbsUpDownIcon from '@material-ui/icons/ThumbsUpDown'

const Wrapper = styled.div`
  margin: ${props => `${props.theme.spacing(6)}px ${-props.theme.spacing(6)}px`};
`

const Score = styled.div`
  display: flex;
  padding: ${props => `${props.theme.spacing(3)}px ${props.theme.spacing(6)}px`};
  border-top: 1px solid ${props => props.theme.palette.black.lighter};

  &:last-of-type {
    border-bottom: 1px solid ${props => props.theme.palette.black.lighter};
  }

  ${props => (props.positive ? `color: ${props.theme.palette.success.main}` : `color: ${props.theme.palette.red.main}`)}
`

const ScoreText = styled.span`
  margin-left: ${props => props.theme.spacing(4)}px;
`

const getNpsProduct = type => {
  const t = parseInt(type)
  switch (t) {
    case 0:
    case 1:
      return 'Traditional Editor'
    case 2:
      return 'Express Editor'
    case 3:
      return 'LogoMaker'
    case 4:
      return 'Creativ.eMail'
    default:
      return 'Unknown'
  }
}

const NpsInfo = ({ account }) => {
  const hasNps = account.netPromoterScores && account.netPromoterScores.length > 0
  return hasNps &&
    <Wrapper>
      {account.netPromoterScores.map(nps => {
        return <Score positive={nps.score >= 6}>
          <ThumbsUpDownIcon />
          <ScoreText>
            {`${nps.score} - ${nps.message} ${nps.message && '-'} ${getNpsProduct(nps.type)}`}
          </ScoreText>
        </Score>
      })}
    </Wrapper>
}

NpsInfo.propTypes = {
  account: PropTypes.object.isRequired
}

export default NpsInfo
